export const defaultOptions = {
  placement: "top",
  trigger: "hover",
  display: true,
  displayMobile: true,
  theme: "dark",
  id: false,
};

export const backwardCompatibilityOptions: any = {};
